import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Collapsible from 'react-collapsible';
import estilos from './FormularioFC30BeneficiarioComponent.module.css';
import { ArchivoComponent } from '../../ArchivosComponents/ArchivoComponent';
import { ArchivoOpcionalComponent } from './ArchivoOpcionalComponent';
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import ModalEnviadoCorrectamente from '../../App/ModalEnviadoCorrectamente';
import {
    actualizarFC_30Estatus, actualizarFileFC_30,
    agregarFileFC_30,
    resetDataFC_30,
    actualizarFC_30Fecha
} from '../../../redux/DucksBeneficiario/FC_30Ducks';
import moment from 'moment'


const DocumentacionFC_30Component = (props) => {
    const dispatch = useDispatch()
    const modoCorreccion = useSelector(store => store.FC_30Solicitud.modoCorreccion)
    let data = useSelector(store => store.FC_30Solicitud.dataDocumentacion)
    console.log('ataaaaaa ', data)
    const fechaHoy = moment().format('YYYY-MM-DD');
    const filesFC_30 = useSelector(store => store.FC_30Solicitud.files)
    const filesProductosFC_30 = useSelector(store => store.FC_30Solicitud.filesProductos)
    let filesMap = useSelector(store => store.FC_30Solicitud.filesMap)
    let filesProductosMap = useSelector(store => store.FC_30Solicitud.filesProductosMap)
    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const [envioCorrecto, setEnvioCorrecto] = React.useState(false)

    const [folio, setFolio] = React.useState('')

    const obtenerNumeroDeFiles = async () => {

        const countArchivos = await countFiles()
        const totalFilesGenerales = (files.filter(file => file.estatus === true)).length
        const totalFilesProductos = (filesProductos.filter(file => file.estatus === true)).length
        const contadorArchivo = totalFilesGenerales + totalFilesProductos

        if (countArchivos > contadorArchivo) {
            setvalidacion(true)
            settexto("")
        } else {
            let fecha = new Date(fechaHoy).toISOString()
            let solicitud = { fechasolicitud: fecha, idfc30_notificaciontrasladodepr: data.idfc30_notificaciontrasladodepr }
            await dispatch(actualizarFC_30Fecha(solicitud))
            setFolio(data.folio)
            const idSolicitud = data.idfc30_notificaciontrasladodepr
            const estatusNuevo = 2
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_30 = 5
            const tabla = tablaFC_30
            await dispatch(actualizarFC_30Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
            ))
            await dispatch(resetDataFC_30())
            setEnvioCorrecto(true)
        }
    }

    const countFiles = async () => {
        let count = 2
        let contador = 0
        if (data.propiasalida && data.propiarecepcion) contador = 0
        if (data.propiasalida && (data.otroclienterecepcion||data.noregistradarecepcion)) contador = data.fc_30_anexoproducto.length * 2
        if (data.noregistradasalida) contador = data.fc_30_anexoproducto.length * 4
        return contador
    }

    React.useEffect(() => {
        if (filesFC_30?.data) {
            let newFiles = []
            for (const file of filesFC_30.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFile(newFiles)
        }

        if (filesProductosFC_30?.data) {
            let newFiles = []
            for (const file of filesProductosFC_30.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFilesProductos(newFiles)
        }

    }, [data])

    /*React.useEffect(() => {
        return () => {
            dispatch(resetDataFC_30())
        }
    }, [])*/

    //FILES GENERALES
    const [files, setFile] = React.useState([])
    const handdleFile = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_30/agregarNuevoFC_30AnexosArchivos'
        }
        const result = await dispatch(agregarFileFC_30(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idfc_30archivos
            objectFile.estatus = true
            setFile(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }


    }

    const handdleRemovePrev = async (objectFile) => {

        if (objectFile) {
            const newFiles = files.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_30/actualizarFormatoFC30_AnexosArchivos'
                }
                const result = await dispatch(actualizarFileFC_30(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_30/agregarNuevoFC_30AnexosArchivos'
                    }
                    result = await dispatch(agregarFileFC_30(data))
                }
                if (result.payload.data?.data) {
                    setFile(newFiles)
                    return true
                } else {
                    const newFiles = files.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFile(newFiles)
                    return false
                }
            }
        }
    }

    // //FILES PRODUCTOS
    //handdleFile: , handdleRemovePrev: , files:  }}
    const [filesProductos, setFilesProductos] = React.useState([])
    const handdleFileProducto = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_30/agregarNuevoFC_30AnexosArchivosProducto'
        }
        const result = await dispatch(agregarFileFC_30(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idfc_30archivoproducto
            objectFile.estatus = true
            setFilesProductos(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }

    }

    const handdleRemoveProductoPrev = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesProductos.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_30/actualizarFormatoFC30_AnexosArchivosProducto'
                }
                const result = await dispatch(actualizarFileFC_30(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_30/agregarNuevoFC_30AnexosArchivosProducto'
                    }
                    result = await dispatch(agregarFileFC_30(data))
                }
                if (result.payload.data?.data) {
                    setFilesProductos(newFiles)
                    return true
                } else {
                    const newFiles = filesProductos.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFilesProductos(newFiles)
                    return false
                }
            }
        }
    }


    const FilesGenerales = () => {
        return (
            <div>
                <Collapsible trigger="Documentación general" className='mb-3'>
                    <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                        <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGJE'} tabla={"FC_30_anexos"}
                            filesMap={filesMap}
                            textLabel={`Juego de cada etiqueta: `} textoTooltip='que ostente el producto por cada presentación y marca (cuando las etiquetas no cuenten con aprobación del Organismo de Certificación para su uso).'
                            idAnexoFK={data.idfc30_notificaciontrasladodepr} />

                        <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGME'} tabla={"FC_30_anexos"}
                            filesMap={filesMap}
                            textLabel={`Muestra del embalaje y Solicitud para la autorización de uso de marca e imagen corporativa COMERCAM (FC-05): `}
                            textoTooltip='cuando el embalaje cuente con el signo distintivo del COMERCAM y/o contraseña oficial NOM. La marca y signo distintivo COMERCAM y/o la contraseña oficial NOM solo pueden utilizarse en producto que cumpla con la NOM-070-SCFI-2016, previa autorización del Organismo de Certificación.'
                            idAnexoFK={data.idfc30_notificaciontrasladodepr} />

                    </div>
                </Collapsible>
            </div>
        )
    }
    const FilesProductosSalidaNo = () => {
        let file = []
        let certificadoAnalisis = []
        return (
            <div>
                <Collapsible trigger="Documentación de productos" className='mb-3'>
                    {data.fc_30_anexoproducto?.map((anexo, index) => (

                        <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            <label className='text-center'>Producto:{Number(index) + Number(1)}</label>
                            {file = anexo.numeroanalisis.split(',')}
                            {certificadoAnalisis = anexo.numerocertificado.split(',')}
                            {file.map((analisis, i) => (
                                <ArchivoComponent api={{ handdleFile: handdleFileProducto, handdleRemovePrev: handdleRemoveProductoPrev, files: filesProductos }} tabla={"FC_30_anexos"}
                                    textLabel={`Análisis de laboratorio ${analisis} :`} idAnexoFK={anexo.idfc30_anexoproducto} id={`DPAL${index}${i}`} textoTooltip=''
                                    filesMap={filesProductosMap}
                                />
                            ))}
                            <ArchivoComponent api={{ handdleFile: handdleFileProducto, handdleRemovePrev: handdleRemoveProductoPrev, files: filesProductos }} tabla={"FC_30_anexos"}
                                textLabel={`Informe de inspección: `} idAnexoFK={anexo.idfc30_anexoproducto} id={`DPII${index}`} textoTooltip=''
                                filesMap={filesProductosMap}
                            />
                            <ArchivoComponent api={{ handdleFile: handdleFileProducto, handdleRemovePrev: handdleRemoveProductoPrev, files: filesProductos }} tabla={"FC_30_anexos"}
                                textLabel={`Dictamen de cumplimiento con la NOM: `} idAnexoFK={anexo.idfc30_anexoproducto} id={`DPD${index}`} textoTooltip=''
                                filesMap={filesProductosMap}
                            />
                            {certificadoAnalisis.map((certificado, i) => (
                                <ArchivoComponent api={{ handdleFile: handdleFileProducto, handdleRemovePrev: handdleRemoveProductoPrev, files: filesProductos }} tabla={"FC_30_anexos"}
                                    textLabel={`Certificado NOM de producto a granel ${certificado}: `} idAnexoFK={anexo.idfc30_anexoproducto} id={`DPCA${index}${i}`} textoTooltip=''
                                    filesMap={filesProductosMap}
                                />
                            ))}

                        </div>
                    ))}

                </Collapsible>
            </div>
        )
    }
    const FilesProductosSalidaRecepcionSi = () => {
        let file = []
        let certificadoAnalisis = []
        return (
            <div>
                <Collapsible trigger="Documentación de productos" className='mb-3'>
                    {data.fc_30_anexoproducto?.map((anexo, index) => (

                        <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            <label className='text-center'>Producto:{Number(index) + Number(1)}</label>
                            {file = anexo.numeroanalisis.split(',')}
                            {certificadoAnalisis = anexo.numerocertificado.split(',')}
                            {file.map((analisis, i) => (
                                <ArchivoOpcionalComponent api={{ handdleFile: handdleFileProducto, handdleRemovePrev: handdleRemoveProductoPrev, files: filesProductos }} tabla={"FC_30_anexos"}
                                    textLabel={`Análisis de laboratorio ${analisis} :`} idAnexoFK={anexo.idfc30_anexoproducto} id={`DPAL${index}${i}`} textoTooltip=''
                                    filesMap={filesProductosMap}
                                />
                            ))}
                            {certificadoAnalisis.map((certificado, i) => (
                                <ArchivoOpcionalComponent api={{ handdleFile: handdleFileProducto, handdleRemovePrev: handdleRemoveProductoPrev, files: filesProductos }} tabla={"FC_30_anexos"}
                                    textLabel={`Certificado NOM de producto a granel ${certificado}: `} idAnexoFK={anexo.idfc30_anexoproducto} id={`DPCA${index}${i}`} textoTooltip=''
                                    filesMap={filesProductosMap}
                                />
                            ))}
                        </div>
                    ))}
                </Collapsible>
            </div>
        )
    }
    const FilesProductosSalidaRecepcionotra = () => {
        let file = []
        let certificadoAnalisis = []
        return (
            <div>
                <Collapsible trigger="Documentación de productos" className='mb-3'>
                    {data.fc_30_anexoproducto?.map((anexo, index) => (

                        <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            <label className='text-center'>Producto:{Number(index) + Number(1)}</label>
                            {file = anexo.numeroanalisis.split(',')}
                            {certificadoAnalisis = anexo.numerocertificado.split(',')}
                            {file.map((analisis, i) => (
                                <ArchivoComponent api={{ handdleFile: handdleFileProducto, handdleRemovePrev: handdleRemoveProductoPrev, files: filesProductos }} tabla={"FC_30_anexos"}
                                    textLabel={`Análisis de laboratorio ${analisis} :`} idAnexoFK={anexo.idfc30_anexoproducto} id={`DPAL${index}${i}`} textoTooltip=''
                                    filesMap={filesProductosMap}
                                />
                            ))}
                            {certificadoAnalisis.map((certificado, i) => (
                                <ArchivoComponent api={{ handdleFile: handdleFileProducto, handdleRemovePrev: handdleRemoveProductoPrev, files: filesProductos }} tabla={"FC_30_anexos"}
                                    textLabel={`Certificado NOM de producto a granel ${certificado}: `} idAnexoFK={anexo.idfc30_anexoproducto} id={`DPCA${index}${i}`} textoTooltip=''
                                    filesMap={filesProductosMap}
                                />
                            ))}
                        </div>
                    ))}
                </Collapsible>
            </div>
        )
    }


    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    return (
        <Fragment>
            <div className='row container ms-5'>
                <div className='ms-5'>
                    {data.propiasalida && (data.otroclienterecepcion || data.noregistradarecepcion) ? FilesProductosSalidaRecepcionotra() :
                        data.propiasalida && data.propiarecepcion ? FilesProductosSalidaRecepcionSi() :
                            (data.noregistradasalida|| data.salida_propductor_maquilador) ? FilesProductosSalidaNo() : ''}
                </div>
                <br />
                {
                    !modoCorreccion &&
                    <div className="text-center ms-5">
                        <button type="submit" onClick={() => obtenerNumeroDeFiles()}
                            className={`btn ${estilos.botonNaranjaRedondo}`}>Finalizar Envío</button>
                    </div>
                }

            </div>
            {envioCorrecto && <ModalEnviadoCorrectamente folioSolicitud={folio}></ModalEnviadoCorrectamente>}
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
        </Fragment>
    )
};

export default withRouter(DocumentacionFC_30Component)
